import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import _ from 'lodash'
import { useCallback } from 'react'
import { useAppSelector } from 'store/configureStore'
import { RootAppState, useAppDispatch } from 'store/configureStore'
import { ShowNewProjectForm } from '../../../store/Application/appActions'
import { LocalizedTypography } from '../../Localization/LocalizedTypography'
import { DialogCloseSaveButtons } from '../DialogActionButtons/DialogCloseSaveButtons'
import ShowToRoleAndStates from '../Portal/ShowToRole'
import './CreateProjectDialog.scss'
import { CreateProjectForm } from './CreateProjectForm/CreateProjectForm'
import { useCreateProject } from './useCreateProject'

export const NewProjectDialog = () => {
  const dispatch = useAppDispatch()
  const { handleSubmit, submitting, setSubmitting } = useCreateProject()

  const { show, isSellerRole } = useAppSelector(
    (state: RootAppState) => state.app.newProjectForm,
    _.isEqual
  )

  const handleClose = useCallback(() => {
    dispatch(ShowNewProjectForm(false, undefined))
    setSubmitting(false)
  }, [dispatch, setSubmitting])

  if (!show) return null

  return (
    <Dialog
      className="new-project-form"
      open={true}
      onClose={(_, reason) => reason !== 'backdropClick' && handleClose()}
      aria-labelledby="form-dialog-title"
      maxWidth="lg"
      fullWidth
      disableRestoreFocus
    >
      <ShowToRoleAndStates seller isBuyerRole={!isSellerRole}>
        <DialogTitle id="form-dialog-title">
          <LocalizedTypography
            translationKey={'project:new-quotation'}
            translationDefaultValue="new quotation"
            variant="h5"
          />
        </DialogTitle>
      </ShowToRoleAndStates>
      <ShowToRoleAndStates buyer isBuyerRole={!isSellerRole}>
        <DialogTitle id="form-dialog-title">
          <LocalizedTypography
            translationKey="project:new-quotation-request"
            translationDefaultValue="new quotation request"
            variant="h5"
          />
        </DialogTitle>
      </ShowToRoleAndStates>
      <DialogContent>
        <CreateProjectForm
          onSubmit={handleSubmit}
          formId="CreateProjectForm"
          isSellerRole={isSellerRole}
        />
      </DialogContent>
      <DialogActions>
        <DialogCloseSaveButtons
          onCloseButtonClicked={handleClose}
          saveButtonFormId="CreateProjectForm"
          saving={submitting}
          saveButtonTranslationKey="common:create"
        />
      </DialogActions>
    </Dialog>
  )
}
